<div *ngIf="bcForm" class="row" id="parent-brouillon">
    <form focusInvalidInput [formGroup]="bcForm" (ngSubmit)="memorize()">
        <div class="row">
            <div class="col-sm-12" style="display: flex; justify-content: space-between;">
                <h2 class="col-sm-6"> Création de bon de commande {{this.bc.societe ? ' sur ' + this.bc.societe.code :
                    ''}}</h2>
                <div class="col-sm-6">
                    
                    <button color="warn" mat-raised-button type="button" (click)="close()">
                        <mat-icon>cancel</mat-icon>Fermer
                    </button>
                    <button [color]="'primary'" mat-raised-button
                        type="button" (click)="openCycleValidation()">
                        <mat-icon>share</mat-icon>Cycle de validation
                    </button>
                    <button matTooltip="Le site est obligatoire pour la mémorisation" color="success" mat-raised-button
                        type="submit">
                        <mat-icon>save</mat-icon>Mémoriser
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <app-bc-form [form]="bcForm" [detailBcInfo]="detailBcInfo" [amountHT]="bcLineHTs"
                    [amountTTC]="bcLineTTCs" [amountTVA]="bcLineTVAs" (changeEmit)="getSelectedCa1($event)"
                    (changeEmit)="getSelectedSite($event)">
                </app-bc-form>
                <br/>
                <app-bcligne-enveloppe-create-form *ngIf="this.bc && this.bc.type === definitionTypeBC.BCEnveloppe"
                            [bcForm]="bcForm"
                            [bc]="bc" 
                            (amountHTsEmit)="calculateHorsTaxes($event)" >
                </app-bcligne-enveloppe-create-form>
                
            </div>
        </div>
    </form>
</div>
<div *ngIf="bcForm === null">
    <div class="row">
        <div class="col-sm-12" style="display: flex; justify-content: space-between;">
            <h3 class="col-sm-6"> Création de BC {{this.bc.societe ? '(' + this.bc.societe.code + ')' : ''}}</h3>
            <div class="col-sm-6">
                <button color="warn" mat-raised-button type="button" (click)="close()">
                    <mat-icon>cancel</mat-icon>Fermer
                </button>
                <button disabled>
                    <mat-icon>save</mat-icon>Mémoriser
                </button>
            </div>
        </div>
    </div>
    <div>
        <mat-spinner class="spinner" mode="indeterminate"></mat-spinner>
    </div>
</div>